module.exports = __webpack_public_path__ + "img/searchFailed.6c07f49d.svg";